import React from "react";
import { Link } from "react-scroll";
import Typewriter from "typewriter-effect";
import { scrollDuration } from "../../../config/commonConfig";
import { useTranslation } from "react-i18next";
import dev from "../../lottie/dev.json";
import Lottie from "lottie-react";

const StandardMenuDefaultIntro = () => {
  const { t } = useTranslation();
  return (
    <section
      id="home"
      className="bg-primary d-flex fullscreen-with-header position-relative"
    >
      <div className="container my-auto py-5 py-lg-0">
        <div className="row py-4">
          <div className="col-lg-7 text-center text-lg-start align-self-center order-1 order-lg-0">
            <h1 className="text-12 fw-300 mb-0 text-uppercase color-white">
              {t('intro.freelanceDeveloper')}
            </h1>
            <h2 className="text-21 fw-600 text-uppercase mb-0 ms-n1 color-white">
              <Typewriter
                options={{
                  strings: [t('intro.competence.1'), t('intro.competence.2'), t('intro.competence.3'), t('intro.competence.4'), t('intro.competence.5'), t('intro.competence.6'), t('intro.competence.7'), t('intro.competence.8'), t('intro.competence.9')],
                  autoStart: true,
                  loop: true,
                }}
              />{" "}
            </h2>
            <Link
              className="btn btn-dark rounded-0 smooth-scroll mt-3"
              duration={scrollDuration}
              style={{ cursor: "pointer" }}
              to="portfolio"
            >
              {t('intro.viewMyWork')}
            </Link>
            <Link
              className="btn text-dark smooth-scroll mt-3 color-white"
              duration={scrollDuration}
              style={{ cursor: "pointer" }}
              to="contact"
            >
              {t('intro.contactMe')}
              <span className="text-4 ms-2">
                <i className="far fa-arrow-alt-circle-down" />
              </span>
            </Link>
          </div>
          <div className="col-lg-5 text-center align-self-center mb-4 mb-lg-0 order-0 order-lg-1">
            <div className="rounded-pill d-inline-block p-3 shadow-lg wow zoomIn bg-light-header">
              <Lottie animationData={dev} />
            </div>
          </div>
        </div>
      </div>
      <Link
        className="scroll-down-arrow text-dark smooth-scroll"
        smooth="easeInOutQuint"
        duration={scrollDuration}
        style={{ cursor: "pointer" }}
        to="about"
      >
        <span className="animated">
          <i className="fas fa-arrow-down" />
        </span>
      </Link>
    </section>
  );
};

export default StandardMenuDefaultIntro;
